import { Link, useNavigate, useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/AuthContext";
import { LOGOUT } from "@/constants/testIds/auth";
import AdminNav from "@/pages/AdminNav";
import EmailPreviewStudio from "@/pages/EmailPreviewStudio";

export default function AdminEmailPreviewsPage() {
  const { emailType } = useParams();
  const navigate = useNavigate();
  const { logout } = useAuth();

  return (
    <div className="mp-shell mp-wide">
      <header className="mp-top">
        <div>
          <p className="mp-kicker">MinutePay</p>
          <h1>Email previews</h1>
          <p className="mp-lead" style={{ marginBottom: 0 }}>
            {emailType
              ? "This is the production renderer. Send Test uses sample data. Send to All Users emails every eligible account with the selected template."
              : "Select a template to preview. Opening a preview does not send email."}
          </p>
        </div>
        <div className="mp-top-actions">
          <Button variant="outline" asChild>
            <Link to="/admin">Admin</Link>
          </Button>
          <Button data-testid={LOGOUT.button} variant="outline" onClick={logout}>
            Log out
          </Button>
        </div>
      </header>

      <AdminNav />

      <EmailPreviewStudio
        selectedId={emailType || ""}
        onSelect={(id) => navigate(`/admin/email-previews/${id}`)}
      />
    </div>
  );
}
